import React from 'react';
import { observer } from 'mobx-react';
import { ListWrapper } from '../../ListWrapper';
import { BillingOrdersTableList } from './BillingOrderTableList';
import { useBillingOrdersFilterParams } from '../../../hooks';
import {
    cleanBillingSystemStore,
    getBillingCompaniesSelect,
    setBillingSystemForcedUpdateTime,
} from '../../../middleware';
import { Catcher } from '../../Catcher';

// ToDo: 12.01.2026 - remake cleanBillingSystemStore with RelationSelect after metge efactor components BillingShowOrder & BillingNewOrder as ApproveMonthlyOrderModalForm
export const BillingOrdersList: React.FC = observer(() => {
    const filterParams = useBillingOrdersFilterParams();
    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanBillingSystemStore}
                filterParams={filterParams}
                setForcedUpdateTime={setBillingSystemForcedUpdateTime}
                getRelationSelect={getBillingCompaniesSelect}
            >
                <BillingOrdersTableList />
            </ListWrapper>
        </Catcher>
    );
});
